import { FourPropertyStatus } from '@/enums';

export const FILL_MAP = {
    [FourPropertyStatus.AVAILABLE]: 'green.500',
    [FourPropertyStatus.RESERVED]: 'orange.500',
    [FourPropertyStatus.RESERVED2]: 'pink.300',
    [FourPropertyStatus.SOLD]: 'blue.500',
};
